var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.9099 83.36L50.6399 73.85L24.3699 83.36C23.7099 83.7 22.9199 83.22 22.9199 82.48V18.28C22.9199 17.73 23.3599 17.29 23.9099 17.29H77.3499C77.8999 17.29 78.3399 17.73 78.3399 18.28V82.48C78.3499 83.22 77.5699 83.7 76.9099 83.36Z",
    fill: "#E46759"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6401 56.14L39.2001 64.1C38.8501 64.34 38.4001 64.01 38.5201 63.61L42.5501 50.28L31.4501 41.86C31.1101 41.6 31.2901 41.07 31.7101 41.06L45.6401 40.78L50.2101 27.62C50.3501 27.22 50.9101 27.22 51.0501 27.62L55.6201 40.78L69.5501 41.06C69.9701 41.07 70.1501 41.61 69.8101 41.86L58.7101 50.28L62.7401 63.61C62.8601 64.01 62.4101 64.35 62.0601 64.1L50.6401 56.14Z",
    fill: "#FFCEC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/Goal.4ff19bd9f2390095d59ec00dba446753.svg";
export { ForwardRef as ReactComponent };